var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.904 48.09c-4.496 0-9.063-2.56-11.729-5.947C11.387 42.143 11 59.662 11 59.662h49.804s1.004-17.597-13.377-17.597c-2.663 3.43-7.028 6.024-11.523 6.024zM46.616 27.088c0 5.04-4.798 14.678-10.722 14.678-5.914 0-10.715-9.64-10.715-14.678 0-5.037 4.798-9.127 10.715-9.127 5.924.003 10.722 4.093 10.722 9.127z",
    fill: "#2E5ECC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.399 22.738c0-.944-1.372-1.707-3.074-1.713V19.08c0-.29.115-7.079-12.393-7.079-12.502 0-12.386 6.79-12.386 7.08v2.014c-.031 0-.056-.009-.084-.009-1.693 0-3.056.75-3.056 1.68v8.233c0 .924 1.366 1.677 3.056 1.677s3.061-.753 3.061-1.677v-8.233c0-.128-.084-.245-.134-.364v-2.246c0-.206-.898-5.33 9.543-5.33 10.444 0 9.36 5.124 9.36 5.33v2.365c-.02.075-.079.14-.079.218v8.422c0 .948 1.381 1.716 3.093 1.716.038 0 .066-.012.103-.012v3.076h-3.068v2.9h6.089l-.031-16.102z",
    fill: "#2E5ECC"
  })));
}

export default SvgExpert;